import {
    SET_HISTORY_PERIOD
} from "@actions/actionTypes";


export function setHistoryPeriod(value) {
    return (dispatch) => {
        dispatch({type: SET_HISTORY_PERIOD, value})
    }
}